var render = function render(_c,_vm){return _c('b-card',{staticClass:"widget mb-4",class:_vm.props.class,attrs:{"id":_vm.props.id,"no-body":_vm.props.noBody}},[(_vm.props.header !== null)?_c('div',{staticClass:"widget-title mb-3"},[_vm._v(_vm._s(_vm.props.header))]):_vm._e(),(_vm.props.loading)?_c('div',{staticClass:"text-center"},[_c('b-spinner')],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }